<template>
  <div class="roll-block" v-bind:class="{ 'is-show': isActive }">
    <div :class="'roll-block__wrapper ' + className">
      <slot name="content"></slot>
    </div>

    <div class="roll-block__button py-8 mt-8 bg-white">
      <div class="btn color-tertiary hover-color-dark" @click="toggleState()">
        <span class="d-block">
          <slot name="text-button-active" v-if="isActive"></slot>
          <slot name="text-button" v-else></slot>
        </span>
        <Icon
          iconName="icon-chevron-down"
          className="ml-8 icon-16 active-rotate-180"
          v-bind:class="{ 'is-active': isActive }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
export default {
  name: "RollBlock",
  components: {
    Icon,
  },
  props: {
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggleState() {
      this.isActive = !this.isActive;
    },
  },
};
</script>

<style lang="scss">
@import "./roll-block.scss";
</style>
